// extracted by mini-css-extract-plugin
export default {"sectionTitle":"style_sectionTitle__E99UU"};